import { render } from "./Fav.vue?vue&type=template&id=192be64e&scoped=true"
import script from "./Fav.vue?vue&type=script&lang=js"
export * from "./Fav.vue?vue&type=script&lang=js"

import "./Fav.vue?vue&type=style&index=0&id=192be64e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192be64e"]])

export default __exports__